export class HsnCodeRequest{
    hsnCodeId : number;
    
    constructor(hsnCodeId : number)
    {
        this.hsnCodeId = hsnCodeId;
        
    }
}
